import AnchorPart from 'components/anchorPart/anchorPart'
import ScrollContainer from 'components/scrollContainer/scrollContainer'
import ScrollSection from 'components/scrollSection/scrollSection'
import ScrollSectionWitthChildren from 'components/scrollSection/scrollSectionWithChildren'
import AnchorButtonContext from 'contexts/anchorButton'
import { useCounterContext } from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import { useContext, useEffect } from 'react'
export default function Urgence() {
   const { setCounter, counterDefault } = useCounterContext()
   const { setHeadband } = useContext(HeadbandContext)
   const { setAnchorButton } = useContext(AnchorButtonContext)
   useEffect(() => {
      setCounter(counterDefault)
      setHeadband("En cas d'urgence")
      setAnchorButton([
         'Liste des SST',
         'Numéros d’urgence',
         'Incident / accident <br>corporel',
         'Urgence médicale<br>/ malaise',
         'Départ de feu /<br>Alarme incendie',
         'Pollution<br>accidentelle',
         'Ouverture portail',
         'Défibrillateurs',
         'Plan du site',
      ])
   }, [])
   return (
      <ScrollContainer>
         <AnchorPart anchor={{ partName: "LISTE DES SST", id: 0 }} />
         <ScrollSection zoneName='Liste SST' />
         <AnchorPart anchor={{ partName: "NUMÉROS D’URGENCE", id: 1 }} />
         <ScrollSection zoneName="Numéros d'urgence" />
         <AnchorPart anchor={{ partName: "INCIDENT / ACCIDENT CORPOREL", id: 2 }} />
         <ScrollSection zoneName={`Incident-Accident corporel`} />
         <AnchorPart anchor={{ partName: "URGENCE MÉDICALE / MALAISE", id: 3 }} />
         <ScrollSection zoneName="Urgence médicale-Malaise" />
         <AnchorPart anchor={{ partName: "DÉPART DE FEU / ALARME INCENDIE", id: 4 }} />
         <ScrollSection zoneName="Départ feu-Alarme incendie" />
         <AnchorPart anchor={{ partName: "POLLUTION ACCIDENTELLE", id: 5 }} />
         <ScrollSection zoneName="Pollution accidentelle majeure" />
         <AnchorPart anchor={{ partName: "OUVERTURE DU PORTAIL", id: 6 }} />
         <ScrollSection zoneName="Ouverture portail" />
         <AnchorPart anchor={{ partName: "LES DÉFIBRILLATEURS", id: 7 }} />
         <ScrollSectionWitthChildren zoneName="Défibrillateurs" />
         <AnchorPart anchor={{ partName: "PLAN DU SITE", id: 8 }} />
         <ScrollSection zoneName="Plan du site" />
      </ScrollContainer>
   )
}
